/*
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2021-12-20 16:44:50
 * @LastEditTime: 2022-03-28 09:38:43
 * @Description:邮箱系统操作日志(账号创建/删除/编辑)
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/sync/emaillog/${action[0]}`;

export default class LOG {
  static LIST(params) {
    return http.get(url`list`, { params });
  }
  static DELETE(data) {
    return http.post(url`delete`, data, formConfig);
  }
}
